<template>
  <section id="menu_emp">
    <ul>

        <router-link v-for="(link,index) in menu" :to="link.path" tag="li" :ref="link.name" @click.native="clickMenu($event,index)">
          <a>
          {{link.name}}
          </a>
        </router-link>
    </ul>
  </section>
</template>

<script>
  export default {
    name: 'menu-emp',
    data () {
      return {
        menu : menu
      }
    },
    methods : {
      clickMenu(event,index){
        eventHub.$emit('getListDemo');
      }
    }}
</script>

<style lang="scss">
  #menu_emp{
    li.router-link-exact-active{
      border-bottom: 2px inset #092239;
    }
  }
</style>


// WEBPACK FOOTER //
// Menu.vue?81a3205a